import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsBonusService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async search({ num_bonus, num_trans, numped, fornecedor, databonus }) {
    const url = unifyParams(`/wmsBonus/search/${this.idconta}`, [
      {
        key: 'num_bonus',
        value: num_bonus,
      },
      {
        key: 'num_trans',
        value: num_trans,
      },
      {
        key: 'numped',
        value: numped,
      },
      {
        key: 'fornecedor',
        value: fornecedor,
      },
      {
        key: 'databonus',
        value: databonus,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async delete(bonusId) {
    await apinode.delete(`/wmsBonus/${bonusId}/${this.idconta}`)
  }
}

export default new WmsBonusService()
